const GetCourseStudent = {
  call(groupNumber) {
    const currentDate = new Date();
    const firstDigit = parseInt(String(groupNumber)[0]);
    const currentYear = currentDate.getFullYear();
    const academicYearStartMonth = 9;
    const lastYearDigit = parseInt(String(currentYear)[3]);
    const currentMonth = currentDate.getMonth() + 1;
    let course = lastYearDigit - firstDigit + 1;

    if (currentMonth < academicYearStartMonth) {
      course -= 1;
    }
    if (course < 0) {
      const twoLastNumberYearDigit = parseInt(`${String(currentYear)[2]}${String(currentYear)[3]}`);
      const currentDecade = Math.floor(currentYear / 10) * 10;
      course = (twoLastNumberYearDigit - firstDigit) - parseInt(`${String(currentDecade)[2]}${String(currentDecade)[3]}`);
      if (course > 5 || course < 0) {
        const previousDecade = currentDecade - 10;
        course = (twoLastNumberYearDigit - firstDigit) - parseInt(`${String(previousDecade)[2]}${String(previousDecade)[3]}`);
      }
    }
    return course;
  },
}

export default GetCourseStudent